module.exports = __webpack_public_path__ + "media/images/back_slide-de508409a39dc298be4991f0b81ff2a2.jpg";